import { CountryViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const getCountryFromCode = (countries: CountryViewModel[], countryCode: string): string => {
  return countries.find(country => country.countryCode === countryCode)?.countryName || '';
};
